import grid2csv from './grid2csv';
import objects2grid from './objects2grid';

export default (params) => grid2csv(objects2grid(params));
